import { atom } from 'recoil';
import { TargetCommission } from '../interfaces/TargetCommissions';

export const targetCommissionToEditAtom = atom({
  key: 'targetCommissionToEdit',
  default: null as TargetCommission | null,
});
